import 'bootstrap';
import '@/assets/css/bootstrap-4.3.1.min.css'

import '@fortawesome/fontawesome-pro/css/all.css'
import 'vue2-animate/dist/vue2-animate.min.css'
import '@/assets/scss/app.scss'
import '@/assets/fonts/Ubuntu/style.scss'

import '@/assets/scss/checkin.scss'
import '@/assets/fonts/BrandonGrotesque/style.scss'

import '@/assets/css/vue-touch-keyboard.css'

import 'script-loader!createjs/builds/1.0.0/createjs.min.js'
import 'script-loader!inobounce/inobounce.min.js'


import Vue from 'vue'
import axios from 'axios'

import VueI18n from "vue-i18n";


import App from './App.vue'
// import ApiService from '@/services/api.service'

import { EventBus } from '@/common/eventbus.js'
import { mapState } from 'vuex'

import { store } from './store'
import router from './router'

Vue.use(VueI18n);

const messages = {
	de: require('./lang/de.json'),
	en: require('./lang/en.json')
}


//TODO: BUG TO FIX
// import '@/assets/js/script.js'


// console.log('Messages:',messages);

// Create VueI18n instance with options
const i18n = new VueI18n({
	locale: "de", // set locale
	messages // set locale messages
});

Vue.config.productionTip = false

/* Load JS for Virtual-Keyboard */

new Vue({
	router,
	i18n,
	store,
	render: h => h(App),

	computed: {
		...mapState('globals', ['app']),
	},
	mounted () {
		// Splash-Screen zeigen
		// this.$router.push('/');

    /*
		// Lokale Voreinstellungen laden
		this.$store.dispatch('localSettings/LOAD').then( ({ localSettings }) => {

			// ApiService.init();
			this.$store.dispatch('h24/LOAD').then( ( data ) => {

				// App ist startklar.
				// this.$router.push('/welcome');

			});
    });
    //*/
	},
	beforeDestroy() {
	},

	methods: {
	}

}).$mount('#app')
